import { render, staticRenderFns } from "./analiseFaturamentoVolume.vue?vue&type=template&id=623d4895&scoped=true&"
import script from "./analiseFaturamentoVolume.vue?vue&type=script&lang=js&"
export * from "./analiseFaturamentoVolume.vue?vue&type=script&lang=js&"
import style0 from "./analiseFaturamentoVolume.vue?vue&type=style&index=0&id=623d4895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d4895",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VCol,VDivider,VIcon,VListItem,VListItemAction,VListItemTitle,VRow,VSelect})
